import React from 'react';
import mailIcon from '../assets/icons/mailIcon.png';
import githubIcon from '../assets/icons/githubIcon.png';
import linkedInIcon from '../assets/icons/linkedInIcon.png';
import useWindowSize from './useWindowSize';

export default function SocialMedia() {
    const isMobile = useWindowSize().isMobile;
    const iconsStyle_ul = {
        display:'grid',
        gridTemplateColumns:'1fr 1fr 1fr',
        gap: isMobile ? '10px' : '20px',
        listStyleType:'none',
        /*margin:'0 0 0 5%',*/
        margin:'0',
        padding:'0',
        /*width:'20vw',*/
        /*height:'10vh',*/
        width: '100%',
        height: '100%',
    }

    const externalNavContainerStyle = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '4vw',
        height: isMobile ? '35px' : '45px',
        width: !isMobile ? '10vw' : '90px',
        display: 'flex',
        /*color:'green',*/
        /*width:'30vw',*/
        alignItems: 'center',
        listStyleType: 'none',        
    }

    const liImgStyle_img = {
        /*width:'calc(10vw)',*/
        width:'100%',
        height:'100%',
        objectFit:'contain',
        /*height:'calc(13vh)',*/
        //margin:'calc(-1vh) calc(0vw)',
        /*position:'relative',*/
    }
    /* the parent to the images is the li and therefor calc values will be relative to the li's values
    so the img calc values are relative to the li which will be relative to the ul (if I use calc) which 
    has a height set to 10vh*/

    return(
        <nav className="external-nav" style = {externalNavContainerStyle}>
            <ul id = "socialIcons" style = {iconsStyle_ul}>
                <li>
                    <a href="mailto:ericdsergio87@icloud.com" target ="_blank" rel="noreferrer">
                        <img style = {liImgStyle_img}                
                        src = {mailIcon} 
                        alt = "mail Icon Link"
                        />
                    </a>
                </li>
                <li>
                    <a href="https://github.com/ericsergio" target ="_blank" rel="noreferrer">
                        <img style = {liImgStyle_img}
                        src = {githubIcon} 
                        alt = "github Icon Link"
                        />
                    </a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/ericsergio/" target ="_blank" rel="noreferrer">
                        <img style = {liImgStyle_img}
                        src = {linkedInIcon} 
                        alt = "LinkedIn Icon Link"
                        />
                    </a>
                </li>
            </ul>
        </nav>
    );
};